import MiniColorRow from '../../header/components/MiniColorRow';
import PriceSlider from './PriceSlider';
import { Panel, connectRange } from 'react-instantsearch-dom';

const ConditionalPricePanel = connectRange(({ min, max, canRefine }) => {
  if (!canRefine || min === max) {
    return null;
  }

  return (
    <Panel>
      <MiniColorRow color="white" text="PREÇO" />
      <PriceSlider attribute="normalized_price" />
    </Panel>
  );
});

export default ConditionalPricePanel;
